import { createI18n } from 'vue-i18n'
import staticText from '@/components/static'
import { ref, Ref } from 'vue'
// import { useSite } from '@/store'

export const changeLang = (val: 'ja' | 'ko' | 'en') => {
  if (!val) return
  localStorage.setItem('__lang__', val)
  local.global.locale.value = val
}
function loadLocaleMessages () {
  const locales = require.context(
    '../',
    true,
    /locales\/[A-Za-z0-9-_,\s]+\.js$/i
  )
  const messages: any = {}
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key).default
    }
  })
  return messages
}
// console.log('useSite',useSite())
const browserLang = navigator.language.split('-')[0] || 'ja'
const originLang = ['ja', 'ko', 'en'].indexOf(browserLang) > -1 ? browserLang : 'ja'
export const langs = ['zh', 'ja', 'ko', 'en', 'ko', 'th']
// 优先取url ?lang 的语言 > 本地缓存 > 浏览器语言
export const lang = (location.href.match(/lang=([^&]+)/i) || [
  null,
  localStorage.__lang__ || originLang || 'ja'
])[1].replace(/(^.*$)/, ($1: string) => (langs.includes($1) ? $1 : 'ja'))

if (lang) {
  localStorage.__lang__ = lang
}

const local:any = createI18n({
  legacy: false,
  locale: lang?.toLowerCase() || 'zh',
  fallbackLocale: 'zh',
  messages: loadLocaleMessages()
})

export const message = loadLocaleMessages()
export const text = message.code[lang] ?? message.code.ja
export const apiText = message.apiCode[lang] ?? message.apiCode.ja

export default (app: any): void => {
  const t = local.global.t
  app.config.globalProperties.t = t
}

type T = (msg: string, obj?: Record<string, unknown>) => string;
/**
 *
 * @param msg
 * @param values
 * @returns
 * @example t('{a}2{c}',{a:1,c:3}) => '123'
 */
export const t = (msg: string, obj?: any) => {
  if (!msg) return ''
  try {
    const val = local.global.t(msg, obj)
    return val || (process.env.NODE_ENV === 'dev' ? msg : '')
  } catch (error) {
    console.log(error, msg, obj, 'error')
    return msg
  }
}

export const fort = (arr: any[], key: any = 'label'): any[] => {
  arr.forEach((v) => {
    v[key] = t(v[key])
  })
  return arr
}

/* eslint-disable */
Array.prototype.fort = function (key) {
  return fort(this, key);
};

/* eslint-disable */
Array.prototype.fix = function (key) {
  this.forEach((v)=>{
    if(v?.fix){
      v.label=v?.fix(v.label)
    }
  })
  return this
};


export const getStatic = (
  name: string,
  fn = (v: any, ...rest: any[]) => v
): Ref => {
  const text = ref();
  function update(name: string, fn: any) {
    try {
      staticText[name][lang]().then((res: any) => {
        text.value = fn(res.default, update);
      });
    } catch (err) {
      staticText[name].ja().then((res: any) => {
        text.value = fn(res.default, update);
      });
    }
  }
  update(name, fn);
  return text;
};
